// extracted by mini-css-extract-plugin
export default {"root":"entrance-price_root__sfRqz"};